interface IDirectory {
  directoryName: string;
  lowerDirectoryName: string;
  isActive: boolean;
  directoryType: string;
  directoryPosition: number;
  id: string;
  organizationId: string;
  description: string;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
}

export class DirectoryModel implements IDirectory {
  directoryName: string = '';
  lowerDirectoryName: string = '';
  isActive: boolean = false;
  directoryType: string = '';
  directoryPosition: number = 1;
  id: string = '';
  organizationId: string = '';
  description: string = '';
  createdDate: Date = new Date();
  modifiedDate: Date = new Date();
  createdBy: string = '';
  modifiedBy: string = '';

  constructor(props: Partial<IDirectory> = {}) {
    Object.assign(this, props);
  }
}
